<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	export default {
		name: "app"
	};
</script>

<style lang="less">
	@import "~@/assets/styles/reset.less";
	@import "~@/assets/styles/icon.less";

	.topTitle {
		font-family: Roboto, Roboto;
		font-weight: 500;
		font-size: 20px;
		color: #000000;
	}

	.backIcon {
		margin-right: 24px;
	}

	.el-container {
		background: #F3F4F6;
	}

	.el-icon-view {
		color: #2563EB;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.el-icon-edit-outline {
		color: #16A34A;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.el-icon-delete {
		color: #cc0000;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.delete {
		color: #cc0000 !important;
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.flex-c {
		justify-content: center;
		flex-direction: column;
	}

	.flex-c-c {
		flex-direction: row;
		justify-content: center;
	}

	.flex-b {
		justify-content: space-between;
	}
	.flex-end{
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.flex-a {
		justify-content: space-around;
	}

	.flex-wrap {
		flex-wrap: wrap;
	}

	.operation-item {
		display: flex;
		align-items: center;
	}

	.pointer {
		cursor: pointer;
	}

	.flex-1 {
		flex: 1;
	}

	.w-24 {
		width: 24%;
	}
	.w-48{
		width: 48%;
	}
	.w-49{
		width: 49%;
	}
	.w-32{
		width: 32%;
	}
	.w-69{
		width: 69%;
	}
	.w-30{
		width: 30%;
	}
	.flex-only{
		display: flex;
	}

	.dialog-body-wrap {
		margin-top: 10px;
		margin-left: 28px;
	}

	h4 {
		font-size: 16px;
	}
	.el-table__row--level-1 {
	  color: #55aaff;
	}
	.el-table__expand-icon{
		margin-left: -20px !important;
	}
</style>